import { Platforms } from "vue-app/types/enums";

export const platformData: Record<
  Exclude<Platforms, Platforms.VtexCms | Platforms.VtexIo>,
  { logo: string; name: string }
> = {
  [Platforms.Shoper]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/shoper.svg",
    name: "Shoper",
  },
  [Platforms.Woocommerce]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/woocomerce.svg",
    name: "Woocommerce",
  },
  [Platforms.IAI]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/idosell.svg",
    name: "IAI",
  },
  [Platforms.Prestashop]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/prestashop.svg",
    name: "Prestashop",
  },
  [Platforms.Shopify]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/shopify.svg",
    name: "Shopify",
  },
  [Platforms.Magento]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/magento.png",
    name: "Magento",
  },
  [Platforms.Magento2]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/magento2.png",
    name: "Magento2",
  },
  [Platforms.Shopgold]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/shopgold.png",
    name: "Shopgold",
  },
  [Platforms.Cscart]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/cscart.png",
    name: "Cscart",
  },
  [Platforms.Shoplo]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/shoplo.png",
    name: "Shoplo",
  },
  [Platforms.Opencart]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/opencart.png",
    name: "Opencart",
  },
  [Platforms.Shopware]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/shopware.png",
    name: "Shopware",
  },
  [Platforms.Atomstore]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/atomstore.png",
    name: "Atomstore",
  },
  [Platforms.Goshop]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/goshop.png",
    name: "Goshop",
  },
  [Platforms.Twoclickshop]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/2click.svg",
    name: "2clickshop",
  },
  [Platforms.Ebexo]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/ebexo.png",
    name: "Ebexo",
  },
  [Platforms.Sote]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/sote.png",
    name: "Sote",
  },
  [Platforms.Sitecore]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/sitecore.png",
    name: "Sitecore",
  },
  [Platforms.Selly]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/selly.png",
    name: "Selly",
  },
  [Platforms.Comarch]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/comarch.png",
    name: "Comarch",
  },
  [Platforms.Vtex]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/vtex.png",
    name: "Vtex",
  },
  [Platforms.Tray]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/tray.png",
    name: "Tray",
  },
  [Platforms.Spreecommerce]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/spree.png",
    name: "Spreecommerce",
  },
  [Platforms.Aptusshop]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/aptusshop.png",
    name: "Aptusshop",
  },
  [Platforms.Skyshop]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/shyshop.svg",
    name: "Skyshop",
  },
  [Platforms.KqsStore]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/kqs_store.png",
    name: "KqsStore",
  },
  [Platforms.Trisoshop]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/triso.png",
    name: "Trisoshop",
  },
  [Platforms.Magazord]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/magazord.png",
    name: "Magazord",
  },
  [Platforms.Selesto]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/selesto.png",
    name: "Selesto",
  },
  [Platforms.Nuvemshop]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/nuvemshop.svg",
    name: "Nuvemshop",
  },
  [Platforms.LojaIntegrada]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/logos/loja.png",
    name: "LojaIntegrada",
  },
  [Platforms.Panorama]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/panorama.png",
    name: "Panorama",
  },
  [Platforms.Irroba]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/irroba.png",
    name: "Irroba",
  },
  [Platforms.Jet]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/jet.png",
    name: "Jet.",
  },
  [Platforms.BwCommerce]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/bw_commerce.png",
    name: "BW Commerce.",
  },
  [Platforms.WBuy]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/wbuy.png",
    name: "wBuy",
  },
  [Platforms.Custom]: {
    logo: "https://d3vhsxl1pwzf0p.cloudfront.net/images/platformsLogo/custom.png",
    name: "Custom",
  },
};

export const languagePlatforms: Record<string, Platforms[]> = {
  pl: [
    Platforms.Shoper,
    Platforms.IAI,
    Platforms.Woocommerce,
    Platforms.Prestashop,
    Platforms.Magento2,
    Platforms.Shopify,
  ],
  en: [
    Platforms.Shopify,
    Platforms.Nuvemshop,
    Platforms.Prestashop,
    Platforms.Woocommerce,
    Platforms.IAI,
    Platforms.Shoper,
  ],
  pt: [
    Platforms.Nuvemshop,
    Platforms.Tray,
    Platforms.Magazord,
    Platforms.Shopify,
    Platforms.LojaIntegrada,
    Platforms.Vtex,
  ],
};
